<template>
    <div class="field-wrap">
        <span @click="onClick" class="object-field-name">
            {{ field.label }}
            <AppExpandChevron v-if="field.spec" :show="showCategory"/>
        </span>
        <span v-if="withObjectSelect && field.spec" @click="onSelect(fieldPath)"
              v-tooltip="'Select full object reference'"
              class="pl-2 text-success clickable">
            <i class="far fa-check"></i>
        </span>
        <span v-if="showDebugName" class="debug-caption mt-1 ml-1">
            {{ field.name }}
        </span>
        <template v-if="field.spec && showCategory">
            <WorkflowObjectField
                v-for="(specField, idx) in field.spec"
                :field="specField"
                :fieldPath="fieldPath.concat(specField.name)"
                :key="idx + getFieldRenderKey(specField)"
                :onSelect="onSelect"
                :withObjectSelect="withObjectSelect"
                :searchExpand="searchExpand"
                @selectCategory="selectCategory"
                :selectedCategories="selectedCategories"
                :showDebugName="showDebugName"
                class="field-wrap"
                />
        </template>
    </div>
</template>

<script>
import AppExpandChevron from '../../../../../components/shared/AppExpandChevron'

export default {
    name: 'WorkflowObjectField',
    components: {AppExpandChevron},
    props: {
        field: {
            type: Object,
            required: true
        },
        fieldPath: {
            type: Array,
            required: true
        },
        onSelect: {
            type: Function,
            required: true
        },
        withObjectSelect: {
            type: Boolean,
            required: false,
            default: false
        },
        searchExpand: {
            type: Boolean,
            default: false
        },
        selectedCategories: {
            type: Object,
            required: false
        },
        showDebugName: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            expand: true
        }
    },
    computed: {
        showCategory() {
            if (this.selectedCategories) {
                if (this.searchExpand) {
                    return Boolean(!this.selectedCategories[this.fieldPath.join('')])
                } else {
                    return Boolean(this.selectedCategories[this.fieldPath.join('')])
                }
            }
            return this.expand
        }
    },
    methods: {
        selectCategory(data) {
            this.$emit('selectCategory', data)
        },

        getFieldRenderKey(field) {
            return JSON.stringify(field)
        },

        onClick() {
            if (this.field.spec) {
                if (this.selectedCategories) {
                    this.selectCategory({
                        expand: this.searchExpand ? !!this.showCategory : !this.showCategory,
                        fieldPath: this.fieldPath.join('')
                    })
                } else {
                    this.expand = !this.expand
                }
            } else {
                this.onSelect(this.fieldPath)
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .field-wrap {
        margin-left: 20px;
        margin-top: 8px;
    }

    .object-field-name {
        border-radius: 4px;
        padding: 2px 8px;
        background: $color-purple-soft;

        &:hover {
            cursor: pointer;
        }
    }
    .debug-caption {
        display: inline-block;
        border-radius: 5px;
        border: 1px solid;
        font-size: 10px;
        padding: 2px;
        margin-top: -3px;
    }
</style>
